const LOAD_DETAIL_ACTIVE_APPLICANT_JOBS           = 'LOAD_DETAIL_ACTIVE_APPLICANT_JOBS'
const LOAD_DETAIL_ACTIVE_APPLICANT_JOBS_SUCCESS   = 'LOAD_DETAIL_ACTIVE_APPLICANT_JOBS_SUCCESS'
const LOAD_DETAIL_ACTIVE_APPLICANT_JOBS_FAILED    = 'LOAD_DETAIL_ACTIVE_APPLICANT_JOBS_FAILED'
const UNMOUNT_DETAIL_ACTIVE_APPLICANT_JOBS        = 'UNMOUNT_DETAIL_ACTIVE_APPLICANT_JOBS'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const jobsDetailActiveApplicantReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DETAIL_ACTIVE_APPLICANT_JOBS:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DETAIL_ACTIVE_APPLICANT_JOBS_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DETAIL_ACTIVE_APPLICANT_JOBS_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DETAIL_ACTIVE_APPLICANT_JOBS:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default jobsDetailActiveApplicantReducer;